const ContentCopyRounded = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    {...props}
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
  >
    <g clipPath="url(#clip0_3707_5796)">
      <path
        d="M5.3335 5.33301V3.46634C5.3335 2.7196 5.3335 2.34624 5.47882 2.06102C5.60665 1.81014 5.81063 1.60616 6.06151 1.47833C6.34672 1.33301 6.72009 1.33301 7.46683 1.33301H12.5335C13.2802 1.33301 13.6536 1.33301 13.9388 1.47833C14.1897 1.60616 14.3937 1.81014 14.5215 2.06102C14.6668 2.34624 14.6668 2.7196 14.6668 3.46634V8.53301C14.6668 9.27974 14.6668 9.65311 14.5215 9.93833C14.3937 10.1892 14.1897 10.3932 13.9388 10.521C13.6536 10.6663 13.2802 10.6663 12.5335 10.6663H10.6668M3.46683 14.6663H8.5335C9.28023 14.6663 9.6536 14.6663 9.93882 14.521C10.1897 14.3932 10.3937 14.1892 10.5215 13.9383C10.6668 13.6531 10.6668 13.2797 10.6668 12.533V7.46634C10.6668 6.7196 10.6668 6.34624 10.5215 6.06102C10.3937 5.81014 10.1897 5.60616 9.93882 5.47833C9.6536 5.33301 9.28023 5.33301 8.5335 5.33301H3.46683C2.72009 5.33301 2.34672 5.33301 2.06151 5.47833C1.81063 5.60616 1.60665 5.81014 1.47882 6.06102C1.3335 6.34624 1.3335 6.7196 1.3335 7.46634V12.533C1.3335 13.2797 1.3335 13.6531 1.47882 13.9383C1.60665 14.1892 1.81063 14.3932 2.06151 14.521C2.34672 14.6663 2.72009 14.6663 3.46683 14.6663Z"
        stroke="white"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_3707_5796">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export default ContentCopyRounded;
